export const navLinksResidential = [
  { href: "/#", label: "Residential Solar Services" },
  { href: "/#", label: "Home Solar Panel Installation" },
  { href: "/#", label: "Mono-SI" },
  { href: "/#", label: "Poly-SI" },
  { href: "/#", label: "TFSC" },
];

export const navLinksCommercial = [
  { href: "/#", label: "Commercial Services" },
  { href: "/#", label: "Business Solar Arrays" },
  { href: "/#", label: "Solar Carport Installations" },
  { href: "/#", label: "Net Metering Setup" },
    { href: "/#", label: "PERC" },
  { href: "/#", label: "BIPV" }
];



export const navEmergingSolarProducts = [
  { href: "/#", label: "Mono-SI" },
  { href: "/#", label: "OPV" }
];

export const navCommunityPrograms = [
  { href: "/#", label: "Community Solar Programs" },
  { href: "/#", label: "Government/Utility Incentive Navigation" },
  { href: "/#", label: "PPA (Power Purchase Agreements)" },
  { href: "/#", label: "Net Metering Setup" },
  { href: "/#", label: "Battery Storage Solutions" },
  { href: "/#", label: "Solar + EV Charger Integration" },
  { href: "/#", label: "Monitoring & Maintenance" }
];